var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!(_vm.hideBreadcrumbs === true) && _vm.catalog.HasBreadcrumb && !_vm.screen.lt.md)?_c('b-breadcrumb',_vm._l((_vm.breaddata),function(crumb,index){return _c('b-breadcrumb-item',{key:index,attrs:{"to":crumb.route,"active":!crumb.active}},[_vm._v(" "+_vm._s(crumb.displayName)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }